// src/firebaseConfig.js
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// Your web app's Firebase configuration
// Replace with your actual config from the Firebase console!
const firebaseConfig = {
    apiKey: "AIzaSyCoKTazRhVJc4Pp_02BXIg_a5Z4XqyUUI4",
    authDomain: "emberanvil-72b3f.firebaseapp.com",
    projectId: "emberanvil-72b3f",
    storageBucket: "emberanvil-72b3f.firebasestorage.app",
    messagingSenderId: "152225131535",
    appId: "1:152225131535:web:0d80d0fa7149774c8ac77a",
    measurementId: "G-P0SS2F6J9Q"
  };

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);

export { auth, db, app };